import { render, staticRenderFns } from "./form_ot.vue?vue&type=template&id=3b5b03bc&scoped=true&"
import script from "./form_ot.vue?vue&type=script&lang=js&"
export * from "./form_ot.vue?vue&type=script&lang=js&"
import style0 from "./form_ot.vue?vue&type=style&index=0&id=3b5b03bc&scoped=true&lang=css&"
import style1 from "./form_ot.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b03bc",
  null
  
)

export default component.exports